import { render } from "./DefaultPieChart.vue?vue&type=template&id=d5ff80da"
import script from "./DefaultPieChart.vue?vue&type=script&lang=js"
export * from "./DefaultPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DefaultPieChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5ff80da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5ff80da', __exports__)) {
    api.reload('d5ff80da', __exports__)
  }
  
  module.hot.accept("./DefaultPieChart.vue?vue&type=template&id=d5ff80da", () => {
    api.rerender('d5ff80da', render)
  })

}


export default __exports__